module.exports = __webpack_public_path__ + "static/media/dealerAssessmentRulesTemplate.e336a08f.xlsx";